export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name'
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description'
  },
  {
    id: 4,
    label: 'Category',
    intlKey: 'table.category'
  },
  {
    id: 5,
    label: 'Is reserved',
    intlKey: 'table.is_reserved'
  },
  {
    id: 6,
    label: 'Action',
    intlKey: 'table.action'
  }
]

export const tableHeadersWithoutAction = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name'
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description'
  },
  {
    id: 4,
    label: 'Category',
    intlKey: 'table.category'
  },
  {
    id: 5,
    label: 'Is reserved',
    intlKey: 'table.is_reserved'
  }
]

export const tableHeadersChildOrgLabels = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name'
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description'
  },
  {
    id: 4,
    label: 'Category',
    intlKey: 'table.category'
  },
  {
    id: 5,
    label: 'Is reserved',
    intlKey: 'table.is_reserved'
  },
  {
    id: 6,
    label: 'Organization',
    intlKey: 'table.organization_name'
  },
  {
    id: 7,
    label: 'Organization Type',
    intlKey: 'table.organization_type'
  }
]
